<div class="dialog">
  <div class="dialog-header">
    <span class="dialog-title">{{ isEdit ? 'Edit role' : 'Add role' }}</span>
    <button type="button" class="close-btn" [disabled]="isLoading" (click)="close()" aria-label="Close">×</button>
  </div>

  <form [formGroup]="form" class="dialog-form">
    <div class="field-row">
      <div class="field"><span class="field-label">Role name</span><input class="text-box-active" formControlName="roleName" /></div>
      <div class="field"><span class="field-label">Role key</span><input class="text-box-active" formControlName="roleKey" /></div>
    </div>
    <div class="field-row">
      <div class="field"><span class="field-label">Priority</span><input type="number" class="text-box-active" formControlName="rolePriority" /></div>
      <div class="field">
        <span class="field-label">Applicable for</span>
        <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
          <mat-select panelClass="ac-select-panel" [disableOptionCentering]="true" formControlName="applicableFor">
            <mat-option value="CENTRAL">Central</mat-option>
            <mat-option value="ESTABLISHMENT">Establishment</mat-option>
            <mat-option value="BOTH">Both</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="field-row">
      <div class="field">
        <span class="field-label">Scope</span>
        <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
          <mat-select panelClass="ac-select-panel" [disableOptionCentering]="true" formControlName="scope">
            <mat-option value="GLOBAL">Global</mat-option>
            <mat-option value="ESTABLISHMENT">Establishment</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="field">
        <span class="field-label">Status</span>
        <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
          <mat-select panelClass="ac-select-panel" [disableOptionCentering]="true" formControlName="status">
            <mat-option [value]="1">Active</mat-option>
            <mat-option [value]="0">Inactive</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="field-row">
      <label class="checkbox-field">
        <input type="checkbox" formControlName="grantsAllAccess" />
        <span class="field-label">Grants all access (super role)</span>
      </label>
    </div>
  </form>

  <div class="dialog-actions">
    <button type="button" class="ac-secondary-btn" (click)="close()">Close</button>
    <button type="button" class="ac-primary-btn" (click)="submit()">{{ isEdit ? 'Save' : 'Add' }}</button>
  </div>
</div>

<app-loader [isLoading]="isLoading"></app-loader>
